import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const s = ({
  title: o,
  titleId: l,
  ...r
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...r,
    children: [
      o ? /* @__PURE__ */ e.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M510.955 872.555c-12.267 0-24.683-.619-36.885-1.856-23.445-2.368-40.533-23.317-38.187-46.741 2.389-23.445 23.275-40.533 46.763-38.165 9.365.96 18.901 1.429 28.309 1.429 152.363 0 276.288-123.947 276.288-276.267 0-152.363-123.925-276.288-276.288-276.288S234.667 358.592 234.667 510.955c0 27.648 4.053 54.912 12.053 81.045 6.891 22.528-5.76 46.379-28.288 53.291-22.507 6.891-46.4-5.76-53.291-28.288-10.496-34.261-15.808-69.931-15.808-106.048 0-199.403 162.219-361.621 361.621-361.621s361.621 162.219 361.621 361.621c0 199.381-162.219 361.6-361.621 361.6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t = i(s);
export {
  t as default
};
